// extracted by mini-css-extract-plugin
export default {"tupacGrid":"gn-z","tupacHeader":"hn-z","tupacHeader2":"in-z","tupacMenu":"jn-z","tupacMenu2":"kn-z","tupacMain":"ln-z","tupacMain2":"mn-z"};